import { render } from "./Account.vue?vue&type=template&id=92c0cc16&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=92c0cc16&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-92c0cc16"

export default script